import React from "react";
import { Container } from "react-bootstrap";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { useIsMobile } from "../../utils/responsive";

export default function Counter() {
  const isMobile = useIsMobile();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <Container fluid className="p-0">
      <div
        className="d-flex justify-content-center"
        style={{ flexDirection: isMobile ? "column" : "row" }}
        ref={ref}
      >
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}

        <div
          className="p-5 border-bottom-black"
          style={{
            width: isMobile ? "100%" : "30%",
            textAlign: "center",
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.5s ease, transform 0.5s ease",
            borderRight: isMobile ? "none" : "1px solid black",
          }}
        >
          <h1 className="display-1 m-0">
            {inView && <CountUp start={0} end={60} duration={2.75} />}
            <strong>+</strong>
          </h1>
          <span className="body-lg m-0">CLIENTS</span>
        </div>
        <div
          className="p-5 border-bottom-black"
          style={{
            width: isMobile ? "100%" : "30%",
            textAlign: "center",
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.5s ease, transform 0.5s ease",
            transitionDelay: "0.2s",
            borderRight: isMobile ? "none" : "1px solid black",
          }}
        >
          <h1 className="display-1 m-0">
            {inView && <CountUp start={0} end={40} duration={2.75} />}
            <strong>+</strong>
          </h1>
          <span className="body-lg m-0">HOMES</span>
        </div>
        <div
          className="p-5 border-bottom-black"
          style={{
            width: isMobile ? "100%" : "30%",
            textAlign: "center",
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.5s ease, transform 0.5s ease",
            transitionDelay: "0.4s",
          }}
        >
          <h1 className="display-1 m-0">
            {inView && <CountUp start={0} end={25} duration={2.75} />}
            <strong>+</strong>
          </h1>
          <span className="body-lg m-0">COLLABS</span>
        </div>

        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
